import TiktokLeadsApiSettingsTab from './tiktok-leads-settings';

export default TiktokLeadsApiSettingsTab;
